import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Analisis/editarAnalisis`, method: 'POST', body: values, token: token})
}
